import React from "react";
import { canPerform } from "../utils/permissions";

export function AddWorkspaceCard({ workspace, role, onAdd }) {
  const allowed = canPerform(role, "manage", workspace.access);
  return (
    <article className="lw-workspace lw-add-card" aria-labelledby={`${workspace.id}-title`}>
      <button type="button" onClick={onAdd} disabled={!allowed}>
        <span className="lw-add-card__plus" aria-hidden="true">+</span>
        <span className="lw-kicker">Customizable panel</span>
        <strong id={`${workspace.id}-title`}>{workspace.title}</strong>
        <span>{allowed ? workspace.summary : "Manage permission is required."}</span>
      </button>
    </article>
  );
}
